export const WHATSAPP_CHAT_TABLE = "whatsappChats"
export const WHATSAPP_CHAT_TABLE_SCHEMA =
  "id, companyId, userId, instanceId, archived, enabled, lastMessageDate, syncId"
